
import { useIsAuthed } from './AuthShieldContext'

interface IAuthShieldButtonProps {
  propsAuthed?: any
  propsUnauthed?: any
  component?: any
  [key: string]: any
}

const AuthShieldComponent = ({
  propsAuthed,
  propsUnauthed,
  component: Component = 'div',
  ...rest
}: IAuthShieldButtonProps) => {
  const isAuthed = useIsAuthed()
  const isAuthedOrDoesNotHaveUnauthedProps = isAuthed || !propsUnauthed
  const props = isAuthedOrDoesNotHaveUnauthedProps ? propsAuthed : propsUnauthed

  return (
    <Component
      {...rest}
      {...props}
    />
  )
}

export default AuthShieldComponent
